import React from 'react';
import { usePagination } from 'react-instantsearch';

import Paginate from '../Paginate';

const SearchPagination = (props) => {
  const {
    previousLabel,
    nextLabel,
  } = props;

  const pagination = usePagination();

  return (
    <div className="row">
      <div className="col-12">
        <Paginate
          currentPage={pagination.currentRefinement}
          totalPages={pagination.nbPages}
          setCurrentPage={(page) => pagination.refine(page)}
          previousLabel={previousLabel}
          nextLabel={nextLabel}
          controlled
        />
      </div>
    </div>
  );
};

export default SearchPagination;
